// Renders **text** segments as <strong> so emphasis stays editable in the admin.
export const Emph = ({ text = "" }) =>
  text.split(/(\*\*[^*]+\*\*)/g).map((part, i) =>
    part.startsWith("**") && part.endsWith("**") ? <strong key={i}>{part.slice(2, -2)}</strong> : part,
  );
